import { render } from "./ShareHolderDeposit.vue?vue&type=template&id=72d6159e"
import script from "./ShareHolderDeposit.vue?vue&type=script&lang=js"
export * from "./ShareHolderDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__